import './about.css'
import avatar from '../../assets/avater_no_wall.png'
import text from "../../text-content.json"

const About = () => {

    return (
        <div className="about-container">
            
            <div className="text-content">
                <h1 className='about-header'>Hi, I am Yichi</h1>
                
                <div className='divider'></div>

                <img className="avatar-mobile" src={avatar} alt='A personal avatar'/>

                <p className='content'>{text.aboutMe.p1}</p>
                <p className='content'>{text.aboutMe.p2}</p>
                <p className='content'>{text.aboutMe.p3}</p>
                <p className='content'>{text.aboutMe.p4}</p>
            </div>
            <img className="avatar" src={avatar} alt='A personal avatar'/>
        </div>
    )
}

export default About;